import React from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom"

const NavLink = ({ href, children, activeHref = "", to = "" }) => {
  return (
    <li className={activeHref === href ? "active" : "nav-item"}>
      <Nav.Link as={Link} to={to} active={activeHref === href} href={"/" + href}>
        {children}
      </Nav.Link>
    </li>
  );
};

export default NavLink;
